import BlueDotsBackground from '../../BlueDotsBackground';
import people from '../../content/people';

export default function ResponsibleAiAdoption() {
  return (
    <>
      <BlueDotsBackground />

      <section id="header" className="text-white px-6 py-8">
        <div className="max-w-4xl mx-auto">
          <header className="text-left">
            <h1 className="text-4xl font-bold text-white">
              Responsible AI Adoption in a People-Centric Company
            </h1>

            <div className="mt-4 flex items-center justify-start gap-4">
              <div className="text-sm text-gray-400">
                <p>10/04/2026</p>
                <p>By Eduardo Goncalves, Founder &amp; CEO, Kernel</p>
              </div>
              <img
                src={people[0].image}
                alt={people[0].name}
                className="w-10 h-10 rounded-full object-cover border-2 border-white/30 shadow-md"
              />
            </div>
          </header>
        </div>
      </section>

      {/* Article Section */}
      <section id="article" className="text-white px-6 py-4">
        <div className="flex items-center justify-center min-h-screen">
          <div className="mb-24 max-w-2xl px-4 text-left">
            <p className="text-sm text-gray-300">
              <span className="font-bold text-white">Introduction</span> <br />
              <br />
              <span className="font-bold text-white">
                AI is not the story. People are.
              </span>{' '}
              The true promise of artificial intelligence is not replacing human
              expertise, but making that expertise more powerful than ever
              before. As we continue to invest in AI at Kernel, our approach
              remains grounded in the principles that have guided our growth
              over the past seven years: putting people first, serving our
              customers exceptionally well, and building a durable company that
              delivers long-term value.
              <br />
              <br />
              <span className="font-bold text-white">
                Our Approach to AI Adoption
              </span>{' '}
              <br />
              <br />
              At Kernel, AI's primary role is to help our customers, partners,
              and employees better understand Market Access, Finance,
              Compliance, and the complex workflows that connect them. By
              analyzing large volumes of data, highlighting anomalies, and
              surfacing insights, AI helps turn information into understanding.
              But technology is only part of the equation. The expertise,
              judgment, and experience of people remain essential. We see AI as
              an amplifier of human capability, not a replacement for it.
              <br />
              <br />
              Our commitment to being a people-first company has not changed. We
              are not using AI to replace employees, reduce our investment in
              talent, or weaken the relationships that define our business. We
              will continue to recruit from colleges and universities, develop
              future industry leaders, and invest in training and mentorship.
              The best outcomes happen when skilled people are empowered by
              great technology. At Kernel, that belief remains at the center of
              our culture.
              <br />
              <br />
              AI is already embedded throughout our platform through
              capabilities such as AI Insights, anomaly detection, and contract
              PDF ingestion. Yet we are intentional about how we innovate.
              Because we are not driven by private equity or venture capital
              expectations, we can focus on long-term value rather than
              short-term headlines. We have built Kernel through steady,
              disciplined growth, and we are approaching AI the same way. We
              will move at a pace that respects our customers' readiness,
              compliance obligations, and business priorities.
              <br />
              <br />
              <span className="font-bold text-white">Conclusion</span> <br />
              <br />
              The future belongs to organizations that combine the power of
              technology with the strengths of people. At Kernel, we are
              embracing AI enthusiastically but responsibly. We will continue to
              innovate, continue to invest in our people, and continue to help
              our customers navigate an increasingly complex industry. AI will
              play an important role in our future, but the foundation of our
              success will remain what it has always been: trusted
              relationships, deep expertise, and a commitment to putting people
              first.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
